import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BackdropConfig } from './backdrop-config.model';
import { ConnectivityFacade } from '../../+state';
import { ConnectivityService } from '../../services';
import { Subscription } from 'rxjs';
import { ToastFacade } from '@symphony-solo/domain/toast/src';
import { ConnectivityStatusEnum } from '../../enums';
import { Router } from '@angular/router';
import { AlertService } from '@symphony-solo/shared/alert/src';
import { Platform } from '@ionic/angular';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src';
@Component({
  selector: 'network-backdrop',
  templateUrl: './network-backdrop.component.html',
  styleUrls: ['./network-backdrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkBackdropComponent implements OnInit, OnDestroy {
  public backdropConfig: BackdropConfig = new BackdropConfig(false, false, false);
  private networkSubscription: Subscription;
  constructor(
    private connectivityFacade: ConnectivityFacade,
    private networkService: ConnectivityService,
    private cdf: ChangeDetectorRef,
    private toastFacade: ToastFacade,
    private router: Router,
    private alertService: AlertService,
    private platform: Platform,
    private companyConfigFacade: CompanyConfigFacade
  ) {
    this.networkService.startCheckConnectivity();
  }
  public ngOnInit(): void {
    this.networkSubscription = this.connectivityFacade.isWifiConnected$.subscribe((status) => {
      this.backdropConfig.visible = status === ConnectivityStatusEnum.NotConnected;
      if (status === ConnectivityStatusEnum.Connected) {
        const currentPath = window.location.pathname;
        this.handleConnectionRestored(currentPath);
      }

      this.cdf.detectChanges();
    });
  }

  private handleConnectionRestored(currentRoute: string): void {
    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      // For mobile
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.alertService.dismissAlert();
          this.companyConfigFacade.getCompanyConfig();
          this.router.navigate([currentRoute]);
      });
    }
  }

  public ngOnDestroy(): void {
    this.networkSubscription.unsubscribe();
  }

  public showNoConnectionToaster(): void {
    this.toastFacade.showToastWarningMessage('No internet connection. Please reconnect to proceed.');
  }
}
